(function () {
  const galleries = document.querySelectorAll('[data-order-ahead-hero-gallery]');

  galleries.forEach((gallery) => {
    const frames = Array.from(gallery.querySelectorAll('[data-order-ahead-hero-frame]'));
    const dots = Array.from(gallery.querySelectorAll('[data-order-ahead-hero-dot]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-order-ahead-hero-thumb]'));
    const prevButton = gallery.querySelector('[data-order-ahead-hero-prev]');
    const nextButton = gallery.querySelector('[data-order-ahead-hero-next]');
    const currentLabel = gallery.querySelector('[data-order-ahead-hero-current]');
    const stage = gallery.querySelector('[data-order-ahead-hero-main]');

    if (!frames.length) {
      return;
    }

    let activeIndex = Math.max(0, frames.findIndex((frame) => frame.classList.contains('is-active')));
    let touchStartX = 0;

    const setActiveIndex = (nextIndex) => {
      activeIndex = (nextIndex + frames.length) % frames.length;

      frames.forEach((frame, index) => {
        const isActive = index === activeIndex;
        frame.classList.toggle('is-active', isActive);
        frame.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
        dot.tabIndex = isActive ? 0 : -1;
      });

      thumbs.forEach((thumb, index) => {
        const isActive = index === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (currentLabel) {
        currentLabel.textContent = String(activeIndex + 1);
      }
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        setActiveIndex(activeIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        setActiveIndex(activeIndex + 1);
      });
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        setActiveIndex(index);
        dot.focus({ preventScroll: true });
      });

      dot.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
          return;
        }

        event.preventDefault();
        const nextIndex = event.key === 'ArrowRight'
          ? (index + 1) % dots.length
          : (index - 1 + dots.length) % dots.length;
        dots[nextIndex].click();
      });
    });

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        setActiveIndex(index);
        thumb.focus({ preventScroll: true });
      });
    });

    if (stage && frames.length > 1) {
      stage.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setActiveIndex(activeIndex + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setActiveIndex(activeIndex - 1);
        }
      });

      stage.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });

      stage.addEventListener('touchend', (event) => {
        const deltaX = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) < 36) {
          return;
        }
        setActiveIndex(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
      }, { passive: true });
    }

    setActiveIndex(activeIndex);
  });
})();
